import {
  Box,
  Card,
  Link,
  Typography,
  styled,
  Stack,
  useTheme,
  alpha,
  Grid,
  useMediaQuery,
} from "@mui/material";
import MailOutlineTwoToneIcon from "@mui/icons-material/MailOutlineTwoTone";
import LocalPhoneTwoToneIcon from "@mui/icons-material/LocalPhoneTwoTone";
import LanguageTwoToneIcon from "@mui/icons-material/LanguageTwoTone";
import { addHttpPrefixToUrl } from "../../utils/addHttpPrefixToUrl";

const FooterWrapper = styled(Card)(
  ({ theme }) => `
        border-radius: 0;
        margin-top: ${theme.spacing(4)};
        margin-bottom: ${theme.spacing(2)};
`
);

function ReviewFooter(props: {
  email: string;
  contactNumber: string;
  website: string;
}) {
  const theme = useTheme();
  const media = useMediaQuery(theme.breakpoints.down("sm"));
  return (
    <Card
      sx={{
        mb: 2,
        mt: 2,
        textAlign: "center",
        transition: `${theme.transitions.create(["box-shadow", "transform"])}`,
        transform: "translateY(0px)",

        "&:hover": {
          transform: "translateY(-10px)",
          boxShadow: `0 2rem 8rem 0 ${alpha(
            theme.colors.alpha.black[100],
            0.05
          )}, 
            0 0.6rem 1.6rem ${alpha(theme.colors.alpha.black[100], 0.15)}, 
            0 0.2rem 0.2rem ${alpha(theme.colors.alpha.black[100], 0.1)}`,
        },
      }}
    >
      <Box
        mt={1}
        mx={3}
        p={0}
        display={"flex"}
        alignItems="center"
        textAlign={"center"}
        justifyContent="space-between"
      >
        <Grid
          container
          sx={{
            justify: "flex-start",
          }}
        >
          <>
            {props.email && (
              <Grid
                item
                xs={12}
                sm={6}
                md={6}
                lg={6}
                alignItems="center"
                sx={{
                  "&:hover": {
                    cursor: "pointer",
                  },
                }}
                onClick={() => {
                  window.open(`mailto:${props.email}`, "_blank");
                }}
              >
                <Typography
                  sx={{
                    wordBreak: "break-all",
                  }}
                  variant="subtitle1"
                >
                  {props.email}
                </Typography>
                <MailOutlineTwoToneIcon />
              </Grid>
            )}
            {props.contactNumber && (
              <Grid
                item
                xs={12}
                sm={6}
                md={6}
                lg={6}
                sx={{
                  "&:hover": {
                    cursor: "pointer",
                  },
                }}
                onClick={() => {
                  window.open(`tel:${props.contactNumber}`, "_blank");
                }}
                alignItems="center"
              >
                <Typography variant="subtitle1">
                  {props.contactNumber}
                </Typography>
                <LocalPhoneTwoToneIcon />
              </Grid>
            )}
            {props.website && (
              <Grid
                item
                xs={12}
                sm={6}
                md={6}
                lg={12}
                sx={{
                  "&:hover": {
                    cursor: "pointer",
                  },
                }}
                onClick={() => {
                  window.open(addHttpPrefixToUrl(props.website), "_blank");
                }}
                alignItems="center"
              >
                <Typography
                  sx={{
                    wordBreak: "break-all",
                  }}
                  variant="subtitle1"
                >
                  {props.website}
                </Typography>
                <LanguageTwoToneIcon />
              </Grid>
            )}
          </>
        </Grid>
      </Box>
    </Card>
  );
}

export default ReviewFooter;
